import { JsonObject } from 'ta-json';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_priceAppearance,
} from '@src/app/generated/GetAllRetailers';
import { PortalAsset } from '@src/app/model/portal-asset';
import { PriceAppearanceInput } from '@src/app/generated/globalTypes';
import { PriceAppearance } from '@ess/jg-rule-executor/dist/src/domain/price-appearance';

/**
 * PriceAppearance
 */
@JsonObject()
export class PortalPriceAppearance extends PriceAppearance {
  static fromGql(
    gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_configuratorOptions_priceAppearance
  ): PortalPriceAppearance {
    return new PortalPriceAppearance(
      gql.font ? PortalAsset.fromGql(gql.font) : null,
      gql.color
    );
  }

  toGqlInput(): PriceAppearanceInput {
    return {
      font: this.font ? (this.font as PortalAsset).toGqlInput() : null,
      color: this.color,
    };
  }
}
